import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset,
  DateField,
  Toggle,
  ToggleGroup,
} from '@ktag/styleguide/dist/react';

import {
  AppFormField, AddressInfo, FormConfigStore, AppSelectField, FormUtils, DeliveryInfo,
} from 'ewp-common';

import FormDataStore from '../../../stores/formDataStore';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
  setAddress?: (val: any) => void;
  setRoute?: Dispatch<SetStateAction<number>>,
  cancel?: () => void
}

const ResidenceInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const {
    state: formDataState
  } = useContext(FormDataStore.FormDataContext);

  const configs = formConfigState?.data?.labelsMap;

  const [isEstimatedStayUnlimited, setEstimatedStay] = useState(formDataState?.personal?.fieldUnlimitedStay);
  
  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.h2PrimaryResidence.labelDisplayName}</h2>
        <Fieldset>
          <AddressInfo
            fieldsConfig={FormUtils.getAddressFieldConfigs('Primary', configs)}
            formDataKey="primaryAddressInfo"
          />
        </Fieldset>
        <h2>{configs.h2SecondaryResidence.labelDisplayName}</h2>
        <Fieldset>
          <DateField
            label={configs.fieldValidFrom.labelDisplayName}
            name={FormUtils.getFieldName(configs.fieldValidFrom)}
            placeholder={configs.fieldValidFrom.labelDescription}
            required
          />
          <AddressInfo
            fieldsConfig={FormUtils.getAddressFieldConfigs('Secondary', configs)}
            formDataKey="secondaryAddressInfo"
          />
          <AppFormField
            config={configs.fieldEstimatedStay}
            type="number"
            size="l"
            min="1"
            max="5"
            value={isEstimatedStayUnlimited ? "" : configs.fieldEstimatedStay.value}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            disabled={isEstimatedStayUnlimited}
            required={!isEstimatedStayUnlimited}
            validate={(value) => {
              if(!isEstimatedStayUnlimited){
                if(value < 1){
                  return "Wert muss grösser oder gleich 1 sein."
                }
                if(value > 5){
                  return "Wert muss kleiner oder gleich 5 sein."
                }
                if(value % 1 != 0){
                  return "Es sind nur ganze Jahre erlaubt."
                }
              }
            }}
          />
          <ToggleGroup name={FormUtils.PERSONAL_DATA_OBJ_KEY + '.fieldUnlimitedStay'} vertical>
            <Toggle value={true} label="Unbegrenzt" checked={isEstimatedStayUnlimited} onChange={(event) => {
              setEstimatedStay(event.target.checked);
              }} />
          </ToggleGroup>
          <AppSelectField
            fieldConfig={configs.fieldReasonForStay}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            options={[
              {
                label: configs.fieldReasonForStayOption1?.labelDisplayName,
                value: configs.fieldReasonForStayOption1?.labelDisplayName,
              },
              {
                label: configs.fieldReasonForStayOption2?.labelDisplayName,
                value: configs.fieldReasonForStayOption2?.labelDisplayName,
              },
              {
                label: configs.fieldReasonForStayOption4?.labelDisplayName,
                value: configs.fieldReasonForStayOption4?.labelDisplayName,
              },
              {
                label: configs.fieldReasonForStayOption5?.labelDisplayName,
                value: configs.fieldReasonForStayOption5?.labelDisplayName,
              },
            ]}
          />
          <DeliveryInfo formConfigs={configs} />
          <AppFormField
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            config={configs.fieldComments}
            multiline
          />
        </Fieldset>
      </div>
    </div>
  );
};

ResidenceInfo.defaultProps = {
  id: '',
  className: 'residenceInfo',
  additionalClassNames: '',
};

export default ResidenceInfo;
